"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicSPBountyHelperFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_stakingPool",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tTokenAdmin",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tonic",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewards",
                type: "uint256",
            },
        ],
        name: "ClaimBounty",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldCooldown",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newCooldown",
                type: "uint256",
            },
        ],
        name: "CooldownChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
        ],
        name: "DeregisterSuccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DisablePullReservesPublicAccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ETHWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "EnablePullReservesPublicAccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newExchangeRate",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "ExchangeRateUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldFallback",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newFallback",
                type: "address",
            },
        ],
        name: "FallbackAddressChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reservesToPull",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "errorCode",
                type: "uint256",
            },
        ],
        name: "PullError",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reserveRecipientAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
        ],
        name: "PullSuccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "errorCode",
                type: "uint256",
            },
        ],
        name: "RegisterError",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
        ],
        name: "RegisterSuccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldReserveRatio",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newReserveRatio",
                type: "uint256",
            },
        ],
        name: "ReserveRatioChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldRecipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newRecipient",
                type: "address",
            },
        ],
        name: "ReserveRecipientChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "errorCode",
                type: "uint256",
            },
        ],
        name: "ResignAdminError",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "ResignAdminSuccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldRewardRatio",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newRewardRatio",
                type: "uint256",
            },
        ],
        name: "RewardRatioChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "xTonicBurned",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicReleased",
                type: "uint256",
            },
        ],
        name: "TonicReleased",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicStaked",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "xTonicMinted",
                type: "uint256",
            },
        ],
        name: "TonicStaked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "xTonicLocked",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "releasableBlockNum",
                type: "uint256",
            },
        ],
        name: "TonicUnstaked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [
            {
                internalType: "address[][]",
                name: "paths",
                type: "address[][]",
            },
        ],
        name: "pendingYieldingAndRewards",
        outputs: [
            {
                internalType: "uint256",
                name: "yieldingAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "skipPull",
                type: "bool",
            },
            {
                internalType: "address[][]",
                name: "paths",
                type: "address[][]",
            },
        ],
        name: "pullAndConvertFull",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class TectonicSPBountyHelperFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_stakingPool, _tTokenAdmin, _tonic, overrides) {
        return super.deploy(_stakingPool, _tTokenAdmin, _tonic, overrides || {});
    }
    getDeployTransaction(_stakingPool, _tTokenAdmin, _tonic, overrides) {
        return super.getDeployTransaction(_stakingPool, _tTokenAdmin, _tonic, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicSPBountyHelperFactory = TectonicSPBountyHelperFactory;
TectonicSPBountyHelperFactory.bytecode = _bytecode;
TectonicSPBountyHelperFactory.abi = _abi;
//# sourceMappingURL=TectonicSPBountyHelperFactory.js.map